import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LandingPage.module.css'; // Scoped styles
import '../styles/global.css'; // Global styles

function LandingPage() {
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const handleAgreeChange = (e) => {
    setAgreed(e.target.checked);
  };

  const handleProceedClick = () => {
    navigate('/profiles');
  };

  return (
    <div className={styles.landingPageContainer}>
      <div className={styles.titleWrapper}>
        <div className={styles.titleBox}>
          <h1 className={styles.titleText}>Welcome to K-Honeymoon!</h1>
        </div>
      </div>

      <div className={styles.contentBackdropWrapper}>
        <div className={styles.agreementPrompt}>
          <p>
            In order to enter, you must agree with the following conditions:<br /><br />
            1. I understand and accept responsibility for your own actions, thus releasing the website owner, the website builder software, its staff, affiliates and advertisers from all legal liability.<br /><br />
            2. I understand money exchanged is for companionship only and anything beyond that is a choice made between two consenting adults and not contracted by the site or its creator(s).<br /><br />
            3. I understand that this is not relevant to any illegal activity and I will not intend or attempt to proceed in any illegal activity.
          </p>

          <div className={styles.checkboxButtonGroup}>
            <label className={styles.agreementLabel}>
              <input
                type="checkbox"
                checked={agreed}
                onChange={handleAgreeChange}
              />
              I have read and agree to the terms.
            </label>

            <button
              type="button"
              className={styles.agreeButton}
              onClick={handleProceedClick}
              disabled={!agreed}
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
